<template>
  <div class="materials-links">
    <div class="materials-links__sdt">
      <h2 class="materials-links__title">Сайты группы компаний СДТ</h2>
      <MaterialsLinksSdtTable :data="dataSource"/>
    </div>
    <div class="materials-links__other">
      <h2 class="materials-links__title">Сайты</h2>
      <MaterialsLinksSdtTable :data="dataSource"/>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import MaterialsLinksSdtTable from '@/components/blocks/MaterialsLinksSdtTable.vue'

export default {
  name: 'MaterialsLinks',
  components: {
    MaterialsLinksSdtTable
  },
  props: {
  },
  setup () {
    const store = useStore()

    const dataSource = computed(() => {
      // данные для отрисовки таблицы
      return store.getters.getNewsDataTable
    })

    return {
      dataSource
    }
  }
}
</script>

<style lang="scss" scoped>
.materials-links {

  &__title {
    margin-bottom: 24px;
    font-size: 24px;
  }

  &__sdt {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 40px;
  }

  &__other {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
